import {defineSlotRecipe} from '@chakra-ui/react3'

export const CONTENT_INFO_VARIANTS = {
    'full:true': {
        button: 'secondaryGhostOnMedia',
        copy: 'contentTeaserOnMedia'
    },
    'full:false': {
        button: 'secondaryGhost',
        copy: 'contentTeaser'
    },
    'split:true': {
        button: 'secondaryGhost',
        copy: 'contentTeaser'
    },
    'split:false': {
        button: 'secondaryGhost',
        copy: 'contentTeaser'
    }
}

const DARKEN_OVERLAY = {
    content: '""',
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 1,
    display: 'block'
}

const DARKEN_BACKGROUNDS = {
    '40%': 'gradient.bottom.darken-40',
    '80%': 'gradient.bottom.darken-80',
    '100%': 'gradient.bottom.darken-100'
}

const contentTeaserRecipe = defineSlotRecipe({
    slots: ['root', 'imageWrapper', 'image', 'content'],
    base: {
        root: {
            minH: {base: '6.875rem', s: '9.375rem'},
            position: 'relative',
            borderRadius: 'm',
            overflow: 'hidden',
            backgroundColor: 'background.section.subtle'
        },
        imageWrapper: {
            overflow: 'hidden',
            position: 'absolute',
            inset: 0
        },
        image: {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            gap: 'spacing-16',
            px: {base: 'spacing-16', s: 'spacing-24'},
            py: {base: 'spacing-20', s: 'spacing-24'}
        }
    },
    variants: {
        variant: {
            full: {
                root: {
                    display: 'flex'
                },
                imageWrapper: {
                    position: 'absolute',
                    inset: 0
                },
                content: {
                    position: 'relative',
                    zIndex: 2,
                    flex: '1 1 auto'
                }
            },
            split: {
                root: {
                    display: 'flex',
                    alignItems: 'stretch'
                },
                imageWrapper: {
                    position: 'relative',
                    flex: '0 0 50%',
                    maxW: '50%'
                },
                image: {
                    position: 'absolute',
                    inset: 0,
                    display: 'block'
                },
                content: {
                    flex: '1 1 50%',
                    maxW: '50%'
                }
            }
        },
        hasImage: {
            false: {
                content: {
                    flex: '1 1 100%',
                    maxW: '100%'
                }
            }
        },
        darken: {
            '0%': {},
            '40%': {},
            '80%': {},
            '100%': {}
        }
    },
    compoundVariants: Object.entries(DARKEN_BACKGROUNDS).map(([darken, bg]) => ({
        variant: 'full',
        hasImage: true,
        darken,
        css: {
            imageWrapper: {
                _before: {
                    ...DARKEN_OVERLAY,
                    bg
                }
            }
        }
    })),
    defaultVariants: {
        variant: 'full',
        darken: '0%'
    }
})

export default contentTeaserRecipe
